/**
 * Abode Studio — Country code to flag emoji mapper
 * Converts ISO 3166-1 alpha-2 country codes to regional indicator flag emojis.
 * Applied to [data-country-code] elements inside the footer country selector.
 */
(function () {
  function codeToFlag(code) {
    if (!code || code.length !== 2) return '';
    var upper = code.toUpperCase();
    return String.fromCodePoint(
      0x1f1e6 + upper.charCodeAt(0) - 65,
      0x1f1e6 + upper.charCodeAt(1) - 65
    );
  }

  function applyFlags() {
    var els = document.querySelectorAll('[data-country-code]');
    for (var i = 0; i < els.length; i++) {
      var code = els[i].getAttribute('data-country-code');
      if (code && !els[i].textContent.trim()) {
        els[i].textContent = codeToFlag(code);
      }
    }
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFlags);
  } else {
    applyFlags();
  }

  // Re-apply flags after localization panel is opened (in case of dynamic rendering)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.abode-country-btn')) {
      requestAnimationFrame(applyFlags);
    }
  });
})();
